import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import * as _ from 'lodash';
const ipv6Reg = /^([\da-fA-F]{1,4}:){6}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^::([\da-fA-F]{1,4}:){0,4}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:):([\da-fA-F]{1,4}:){0,3}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){2}:([\da-fA-F]{1,4}:){0,2}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){3}:([\da-fA-F]{1,4}:){0,1}((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){4}:((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^:((:[\da-fA-F]{1,4}){1,6}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^[\da-fA-F]{1,4}:((:[\da-fA-F]{1,4}){1,5}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){2}((:[\da-fA-F]{1,4}){1,4}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){3}((:[\da-fA-F]{1,4}){1,3}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){4}((:[\da-fA-F]{1,4}){1,2}|:)(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){5}:([\da-fA-F]{1,4})?(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$|^([\da-fA-F]{1,4}:){6}:(\/([1-9]?\d|(1([0-1]\d|2[0-8]))))?$/;
const reg = /^[0-9]*$/;
const tel = /^(((2[0-4]\d|25[0-5]|1\d\d|0|[1-9]\d?)\.){3}(2[0-4]\d|25[0-5]|1\d\d|0|[1-9]\d?)((,|\||;)((2[0-4]\d|25[0-5]|1\d\d|0|[1-9]\d?)\.){3}(2[0-4]\d|25[0-5]|1\d\d|0|[1-9]\d?))*)$/;

//入站、出站规则效验
function sgRulesCheck(rules: any, me: any, getDhcp: any) {
    let arrCloneAdd: any[] = [];
    let onOffPort = false;
    let onOffPortSize = false;

    let inIps: any[] = [];
    _.forEach(rules, (item, id) => {
        if (item.Protocol == "healthy") {
            item.CidrBlock = me.reverse;
        }
        arrCloneAdd.push(item)
        item.isError = false;
        // if (item.Protocol == "tcp" || item.Protocol == "udp") {
        //     if (!item.PortRangeFrom || !item.PortRangeTo || !reg.test(item.PortRangeFrom) || !reg.test(item.PortRangeTo) || Number(item.PortRangeFrom) > 65535 || Number(item.PortRangeFrom) < 1 || Number(item.PortRangeTo) > 65535 || Number(item.PortRangeTo) < 1) {
        //         onOffPort = true;
        //         item.isError = true;
        //         item.errorMsg = Vue.$trans(`起始端口和结束端口范围：1-65535`);
        //     } else if (Number(item.PortRangeFrom) > Number(item.PortRangeTo)) {
        //         onOffPortSize = true;
        //         item.isError = true;
        //         item.errorMsg = Vue.$trans(`结束端口必须大于起始端口`);
        //     } else {
        //         item.isError = false;
        //         onOffPortSize = false;
        //         onOffPort = false;
        //     }
        // }
        
        if (item.Protocol == "tcp" || item.Protocol == "udp") {
            if (item.ProtocolPort && item.ProtocolPort.length) { // 编辑出入站规则时批量添加协议端口
                _.forEach(item.ProtocolPort, port => {
                    const splitPort = _.toString(port).split("-");
                    const PortRangeFrom = splitPort.length > 1 ? splitPort[0] : port;
                    const PortRangeTo = splitPort.length > 1 ? splitPort[1] : port;
                    if (!PortRangeFrom || !PortRangeTo || !reg.test(PortRangeFrom) || !reg.test(PortRangeTo) || Number(PortRangeFrom) > 65535 || Number(PortRangeFrom) < 1 || Number(PortRangeTo) > 65535 || Number(PortRangeTo) < 1) {
                        onOffPort = true;
                        item.isError = true;
                        item.errorMsg = Vue.$trans(`起始端口和结束端口范围：1-65535`);
                    } else if (Number(PortRangeFrom) > Number(PortRangeTo)) {
                        onOffPortSize = true;
                        item.isError = true;
                        item.errorMsg = Vue.$trans(`结束端口必须大于起始端口`);
                    }
                })
            } else {
                if (!item.PortRangeFrom || !item.PortRangeTo || !reg.test(item.PortRangeFrom) || !reg.test(item.PortRangeTo) || Number(item.PortRangeFrom) > 65535 || Number(item.PortRangeFrom) < 1 || Number(item.PortRangeTo) > 65535 || Number(item.PortRangeTo) < 1) {
                    onOffPort = true;
                    item.isError = true;
                    item.errorMsg = Vue.$trans(`起始端口和结束端口范围：1-65535`);
                } else if (Number(item.PortRangeFrom) > Number(item.PortRangeTo)) {
                    onOffPortSize = true;
                    item.isError = true;
                    item.errorMsg = Vue.$trans(`结束端口必须大于起始端口`);
                }
            }
        }

        if (item.CidrBlock) {
            let ips = item.CidrBlock.split(',');
            let PortRangeFrom = item.PortRangeFrom;
            let PortRangeTo = item.PortRangeTo;
            let IcmpType = item.Protocol == "icmp" ? item.IcmpType : null;
            let IcmpCode = item.Protocol == "icmp" ? item.IcmpCode : null;
            if (ips) {
                // 去重 mlgbd
                _.forEach(ips, ip => {
                    let ruleItem = `${item.Protocol}|${item.Policy}|${PortRangeFrom}|${PortRangeTo}|${IcmpType}|${IcmpCode}|${ip}`;
                    if (item.CidrBlocks && item.CidrBlocks.length) {
                        if (item.Protocol == "icmp") {
                            IcmpType = item.IcmpType == "-1" ? "-1" : item.IcmpType.split("-")[0];
                            IcmpCode = item.IcmpType == "-1" ? "-1" : item.IcmpType.split("-")[1];
                        }
                        if (item.Protocol == "tcp" || item.Protocol == "udp") {
                            if (item.ProtocolPort && item.ProtocolPort.length) {
                                _.forEach(item.ProtocolPort, subitem => {
                                    const splitPort = _.toString(subitem).split("-");
                                    PortRangeFrom = splitPort.length > 1 ? splitPort[0] : subitem;
                                    PortRangeTo = splitPort.length > 1 ? splitPort[1] : subitem;
                                    ruleItem = `${item.Protocol}|${item.Policy}|${PortRangeFrom}|${PortRangeTo}|${IcmpType}|${IcmpCode}|${ip}`;
                                    if (inIps.indexOf(ruleItem) !== -1) {
                                        item.isError = true;
                                        item.errorMsg = "多条规则的网段不能重复";
                                    }
                                    inIps.push(ruleItem);
                                });
                            }
                        } else {
                            ruleItem = `${item.Protocol}|${item.Policy}|${PortRangeFrom}|${PortRangeTo}|${IcmpType}|${IcmpCode}|${ip}`;
                            if (inIps.indexOf(ruleItem) !== -1) {
                                item.isError = true;
                                item.errorMsg = "多条规则的网段不能重复";
                            }
                            inIps.push(ruleItem);
                        }
                    } else {
                        if (inIps.indexOf(ruleItem) !== -1) {
                            item.isError = true;
                            item.errorMsg = '多条规则的网段不能重复';
                        }
                        inIps.push(ruleItem);
                    }
                    
                });

                if (ips.length > 1) {
                    if (!item.RuleTag) {
                        item.isError = true;
                        item.errorMsg = '规则包含多个IP段，TAG不能为空';
                    } else if (!me.supportSgTag) {
                        item.isError = true;
                        item.errorMsg = '当前数据中心不支持多IP段';
                    }
                }
            }

            let ok = _.every(ips, CidrBlock => {
                var cirIp = CidrBlock.split('/')[0];
                var cirNum = CidrBlock.split('/')[1];
                if (!CidrBlock || !cirIp || !cirNum || CidrBlock.split('/').length != 2 || !tel.test(cirIp) || !reg.test(cirNum) || Number(cirNum) > 32 || Number(cirNum) < 0 || !getDhcp.commonDhcp(cirIp, cirNum) || (cirIp == "0.0.0.0" && cirNum != 0)) {

                    if (item.Protocol == "tcp" || item.Protocol == "udp") {
                        if (me.onOffPort || me.onOffPortSize) {
                            return;
                        }
                    }

                    if(me.isGlobalGroup && ipv6Reg.test(CidrBlock)) {
                        item.isError = true;
                        item.errorMsg = '全局安全组不支持IPv6地址';
                        return;
                    }

                    if (me.isGlobalGroup) {
                        item.isError = true;
                        item.errorMsg = '源IP或目标IP必须是网段或者是IPv6地址';
                        return
                    }

                    if (!ipv6Reg.test(CidrBlock)) {
                        item.isError = true;
                        item.errorMsg = '源IP或目标IP必须是网段或者是IPv6地址';
                        return
                    }
                    
                    if (!me.currVpcSupportIpv6 && ipv6Reg.test(CidrBlock)) {
                        item.isError = true;
                        item.errorMsg = '必须是开启IPv6的VPC才能够添加IPv6地址';
                        return
                    }
                    
                }
                return true
            });
            if (!ok) {
                return;
            }
        } else {
            item.isError = true;
            item.errorMsg = '请检查源IP或目标IP是否填写正确';
            return
        }

        if (me.interfaceEpcCount && !me.sgSupportEpcDeny && item.Policy == "Drop") {
            item.isError = true;
            item.errorMsg = Vue.$trans(`裸金属服务器不支持安全组“拒绝”规则，安全组已绑定裸金属服务器，无法设置“拒绝”规则。`);
        }

    })

    return arrCloneAdd;
}

export default {
    sgRulesCheck
};
